const getEventData = (type, subType, contents) => ({
  event: {
    type,
    subtype: subType,
    is_interaction: 'true',
    contents,
  },
});

export default getEventData;
